(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdm-gallery"] && !Shopify.designMode) return;
  try {
    
function setupMdmGallery() {
  const root = document.getElementById('MainContent');
  if (!root) return;
  const filters = root.querySelector('.mp-filters');
  const more = root.querySelector('[data-mdm-gallery-more]');
  const load = root.querySelector('[data-gallery-load]');
  const count = root.querySelector('[data-gallery-count]');
  if (!filters || !more || !load || !count) return;
  const cards = Array.from(root.querySelectorAll('.mp-gallery-card[data-category]'));
  const parts = Array.from(root.querySelectorAll('[data-mdm-gallery-part]'));
  const progress = root.querySelector('[data-gallery-progress]');
  const end = root.querySelector('[data-gallery-end]');
  const batch = 24;
  let selected = root.dataset.mdmGalleryFilter || 'all';
  let limit = Number(root.dataset.mdmGalleryLimit) || batch;
  function update() {
    root.dataset.mdmGalleryFilter = selected;
    root.dataset.mdmGalleryLimit = String(limit);
    const matches = cards.filter((card) => selected === 'all' || card.dataset.category === selected);
    const visible = new Set(matches.slice(0, limit));
    cards.forEach((card) => { card.hidden = !visible.has(card); });
    parts.forEach((part) => { part.hidden = !part.querySelector('.mp-gallery-card:not([hidden])'); });
    const status = count.dataset.countTemplate.replace('VISIBLE_COUNT', String(visible.size)).replace('TOTAL_COUNT', String(matches.length));
    count.textContent = status;
    progress.textContent = status;
    load.hidden = visible.size >= matches.length;
    end.hidden = visible.size < matches.length;
    filters.querySelectorAll('[data-filter]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.filter === selected)));
  }
  filters.hidden = false;
  more.hidden = false;
  filters.onclick = (event) => {
    const button = event.target.closest('[data-filter]');
    if (!button) return;
    selected = button.dataset.filter;
    limit = batch;
    update();
  };
  load.onclick = () => {
    const priorVisible = new Set(cards.filter((card) => !card.hidden));
    limit += batch;
    update();
    const next = cards.find((card) => !card.hidden && !priorVisible.has(card));
    if (next) {
      next.setAttribute('tabindex', '-1');
      next.focus({ preventScroll: true });
      next.scrollIntoView({ block: 'start', behavior: 'instant' });
    }
  };
  update();
}
setupMdmGallery();
document.addEventListener('shopify:section:load', setupMdmGallery);
document.addEventListener('shopify:block:select', (event) => { const card = event.target.closest('.mp-gallery-card'); if (card) { card.hidden = false; card.closest('[data-mdm-gallery-part]').hidden = false; } });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdm-home"] && !Shopify.designMode) return;
  try {
    
function openMdmMaterialDirectory() {
  const id = window.location.hash.slice(1);
  if (id !== 'mdm-manufactured' && id !== 'mdm-thin-brick') return;
  const directory = document.getElementById(id);
  if (directory) directory.open = true;
}
document.addEventListener('click', (event) => {
  const link = event.target.closest('.mdm-category');
  if (!link) return;
  const href = link.getAttribute('href');
  if (href !== '#mdm-manufactured' && href !== '#mdm-thin-brick') return;
  const directory = document.querySelector(href);
  if (directory) directory.open = true;
});
window.addEventListener('hashchange', openMdmMaterialDirectory);
openMdmMaterialDirectory();

  } catch(e) { console.error(e); }
})();
})();
